<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div
          class="modal-container amb-modal-container"
          :class="{'wide': isWide, 'extra-tall': extraTall, 'medium-wide': isMediumWide, 'fullscreen': isFullscreen, 'small-wide': isSmallWide, 'is-800': is800}"
        >
          <div class="modal-body p-0">
            <!-- :style="scrollable" -->
            <slot>
              <!-- Body of the Modal -->
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ApplicationModal',
  props: [
    "isWide",
    "extraTall",
    "isMediumWide",
    "isFullscreen",
    "isSmallWide",
    "is800"
  ],
  data() {
    return {
      visible: true,
      scrollable: {
        maxHeight: window.innerHeight * 0.95 + "px",
        overflowY: "auto",
        overflowX: "hidden"
      }
    };
  },
  methods: {
    closeButtonClick() {
      this.$emit("close");
      location.reload();
    }
  }
};
</script>

<style scoped>
.wide {
  width: 80% !important;
}

.fullscreen {
  width: 100vw!important;
  height: 100vh!important;
  max-height: 100vh!important;
}

.extra-tall {
  max-height: 2000px !important;
  -ms-overflow-y: auto !important;
  overflow-y: auto !important;
}

.medium-wide {
  width: 60% !important;
}

.is-800 {
  /* because 800 is magic according to a bigot */
  width: 800px !important;
}

.small-wide {
  width: 40% !important;
}

.modal-mask {
  position: fixed;
  z-index: 1022;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease-in-out;
}

.modal-container {
  width: 600px;
  margin: 0 auto;
  padding: 20px 10px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease-in-out;
  position: relative;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 0;
}

body .modal-body .amb-close-modal svg {
  color: #fff !important;
}

/*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
